import { render, staticRenderFns } from "./AmazeActivityEmailControls.vue?vue&type=template&id=5314900a"
import script from "./AmazeActivityEmailControls.vue?vue&type=script&lang=js"
export * from "./AmazeActivityEmailControls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports